import { render, staticRenderFns } from "./Approvement.vue?vue&type=template&id=7198898a&scoped=true&"
import script from "./Approvement.vue?vue&type=script&lang=js&"
export * from "./Approvement.vue?vue&type=script&lang=js&"
import style0 from "./Approvement.vue?vue&type=style&index=0&id=7198898a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7198898a",
  null
  
)

export default component.exports